import builder from '../builder';
import AccountingInvoice from '../../streamline-icons/light/accounting-invoice.svg';

export default builder('IconAccountingInvoiceLight', AccountingInvoice);
